export default function getRandomInt() {
    return Math.floor(Math.random())+2*Date.now();
}


export const numberFormat = function (number) {
    return (number || "")
      .toString()
      .replace(/^0|\./g, "")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
export const priceFormat = function (number) {
    return number ? `${numberFormat(number)}` : `0`;
}

export const formatNumberWithAbbreviation = (numStr, isTotal = false) => {
  if (!numStr) return '';
  const cleaned = numStr.toString().replace(/,/g, '');
  const num = parseFloat(cleaned);
  if (isNaN(num)) return numStr;

  const limit = isTotal ? 26000000000000000 : 100000000;

  if (num >= limit) {
    if (num >= 1000000000000) {
      return (num / 1000000000000).toLocaleString('en-US', {maximumFractionDigits: 2}) + ' تريليون';
    }
    if (num >= 1000000000) {
      return (num / 1000000000).toLocaleString('en-US', {maximumFractionDigits: 2}) + ' مليار';
    }
    if (num >= 1000000) {
      return (num / 1000000).toLocaleString('en-US', {maximumFractionDigits: 2}) + ' مليون';
    }
  }

  const parts = cleaned.split('.');
  if (parts[0] !== undefined && !isNaN(parseInt(parts[0]))) {
    parts[0] = parseInt(parts[0]).toLocaleString('en-US');
  }
  return parts.join('.');
}